'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'LearningCenterUI/components/I18n';
import emptyFunction from 'react-utils/emptyFunction';
import UIButton from 'UIComponents/button/UIButton';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIIllustration from 'UIComponents/image/UIIllustration';
import ContentControlWrapper from '../ContentControlWrapper';
import InterstitialContentViewport from './InterstitialContentViewport';
const BASE_CLASS_NAME = 'basic-interstitial';

const BasicInterstitial = ({
  buttonLink,
  buttonI18n,
  buttonUse,
  illustrationName,
  headingI18n,
  onButtonClick,
  subheadingI18n,
  testId,
  use
}) => /*#__PURE__*/_jsxs("div", {
  className: `${BASE_CLASS_NAME} ${BASE_CLASS_NAME}--${use}`,
  "data-test-id": testId,
  children: [/*#__PURE__*/_jsxs(InterstitialContentViewport, {
    use: use,
    wrapperClassName: `${BASE_CLASS_NAME}__content`,
    wrapperStyle: {
      minHeight: '450px',
      padding: '50px'
    },
    children: [illustrationName && /*#__PURE__*/_jsx(UIIllustration, {
      name: illustrationName,
      width: "110"
    }), /*#__PURE__*/_jsx("p", {
      className: `${BASE_CLASS_NAME}__heading`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: headingI18n
      })
    }), /*#__PURE__*/_jsx("p", {
      className: `${BASE_CLASS_NAME}__subheading`,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: subheadingI18n
      })
    })]
  }), /*#__PURE__*/_jsx(ContentControlWrapper, {
    children: buttonLink ? /*#__PURE__*/_jsx(UIRouterButton, {
      className: `${BASE_CLASS_NAME}__next-button`,
      onClick: onButtonClick,
      to: buttonLink,
      use: buttonUse,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: buttonI18n
      })
    }) : /*#__PURE__*/_jsx(UIButton, {
      className: `${BASE_CLASS_NAME}__next-button`,
      onClick: onButtonClick,
      use: buttonUse,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: buttonI18n
      })
    })
  })]
});

BasicInterstitial.defaultProps = {
  buttonUse: 'primary',
  onButtonClick: emptyFunction,
  testId: 'interstitial',
  use: 'info'
};
BasicInterstitial.propTypes = {
  buttonI18n: PropTypes.string.isRequired,
  buttonLink: PropTypes.string,
  buttonUse: PropTypes.string,
  headingI18n: PropTypes.string.isRequired,
  illustrationName: UIIllustration.propTypes.name,
  onButtonClick: PropTypes.func,
  subheadingI18n: PropTypes.string.isRequired,
  testId: PropTypes.string,
  use: PropTypes.oneOf(['success', 'info'])
};
export default BasicInterstitial;